var _defs, _rect, _rect2, _rect3, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHero1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1600,
    height: 900,
    viewBox: "0 0 1600 900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ea5e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#6366f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a855f7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow",
    cx: "30%",
    cy: "30%",
    r: "70%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "icons",
    width: 220,
    height: 220,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.28,
    stroke: "#ffffff",
    strokeWidth: 4,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 50 v40 a35 35 0 0 0 70 0 v-40",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 140 a25 25 0 0 0 50 0",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 140,
    r: 10,
    fill: "#ffffff",
    opacity: 0.55
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.18,
    transform: "translate(110 130)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 52,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#glow)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#icons)",
    opacity: 0.55
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1180,
    cy: 220,
    r: 210,
    fill: "#22c55e"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1290,
    cy: 270,
    r: 160,
    fill: "#06b6d4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 720,
    r: 240,
    fill: "#f59e0b"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 170,
    r: 160,
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero1);
export default __webpack_public_path__ + "static/media/hero-1.f707c74007770061159676b5fe2a1f1d.svg";
export { ForwardRef as ReactComponent };